// Assets
import solVidOne from '../../assets/videos/01-sol-dopamine.mp4';
import solVidTwo from '../../assets/videos/02-sol-norepinephrine.mp4';
import solVidThree from '../../assets/videos/03-sol-serotonin.mp4';

import wpaVidOne from '../../assets/videos/04-wpa-dopamine.mp4';
import wpaVidTwo from '../../assets/videos/05-wpa-norepinephrine.mp4';
import wpaVidThree from '../../assets/videos/06-wpa-serotonin.mp4';

import amphVidOne from '../../assets/videos/07-amph-dopamine.mp4';
import amphVidTwo from '../../assets/videos/08-amph-norepinephrine.mp4';
import amphVidThree from '../../assets/videos/09-amph-serotonin.mp4';

import dopeThumbnail from '../../assets/videos/dopamine-thumbnail.png';
import noreThumbnail from '../../assets/videos/norepinephrine-thumbnail.png';
import seroThumbnail from '../../assets/videos/serotonin-thumbnail.png';

import stitchVidOne from '../../assets/videos/stitched-sol.mp4';
import stitchVidTwo from '../../assets/videos/stitched-wpa.mp4';
import stitchVidThree from '../../assets/videos/stitched-amph.mp4';
import stitchPic from '../../assets/videos/stitched-thumbnail.png';

import isiPDF from '../../assets/pdfs/isi-sol.pdf';

export default {
  defaultState: {
    route: {
      label: 'TONES 3',
      value: 'tones-3',
    },
  },
  // Landing Page
  landing: {
    bgColor: '#4788a8',
    title: 'Solriamfetol Data Visualizer',
    lastUpdate: 'November 2, 2021',
    description:
      'Explore clinical trial data and mechanism of action for solriamfetol for the treatment of excessive daytime sleepiness in obstructive sleep apnea.',
    disclaimer: 'Confidential - for reactive medical response only.',
    buttonMenuList: {
      firstSet: [
        {
          label: 'Mechanism of Action',
          value: 'Mechanism of Action',
          globalNavLabel: 'MOA',
          route: 'mechanism',
          doNotOpenTopMenuOnClick: true,
          hideNavigationFooter: true,
        },
      ],
      secondSet: [
        {
          label: 'TONES 3',
          value: 'tones-3',
        },
        {
          label: 'TONES 5',
          value: 'tones-5',
        },
        {
          label: 'Indirect Treatment Comparison (ITC)',
          value: 'itc',
        },
        {
          label: 'Driving Study',
          value: 'driving',
          hasRadius: true,
        },
      ],
    },
    buttonMenuBgColor: '#5f9ab4',
    iconButtonList: [
      {
        label: 'Glossary',
        icon: 'glossary',
      },
      {
        label: 'References',
        icon: 'list',
      },
      {
        label: 'ISI',
        icon: 'isi',
        download: isiPDF,
      },
      {
        label: 'Help',
        icon: 'help',
      },
    ],
  },

  //modals
  modals: {
    glossary: [
      [
        ['2°', 'secondary'],
        ['ABPM', 'ambulatory blood pressure monitoring'],
        ['AEs', 'adverse events'],
        ['BL', 'baseline'],
        ['BP', 'blood pressure'],
        ['BMI', 'body mass index'],
        ['bpm', 'beats per minute'],
        ['CGI-C', 'Clinician Global Impression of Change'],
        ['CGI-S', 'Clinical Global Impression of Severity'],
        ['CI', 'confidence interval'],
        ['CPAP', 'continuous positive airway pressure'],
        ['CrI', 'credible interval'],
        ['CS', 'current study'],
        ['DAT', 'dopamine transporter'],
        ['DBP', 'diastolic blood pressure'],
        [
          'DSM-5',
          'Diagnostic and Statistical Manual of Mental Disorders, 5th Edition',
        ],
        ['EDS', 'excessive daytime sleepiness'],
        ['EQ-5D-5L', 'EuroQoL 5 Dimension 5 Level'],
        ['ESS', 'Epworth Sleepiness Scale'],
        ['FOSQ-10', 'Functional Outcome of Sleep Questionnaire'],
        ['FU', 'follow-up'],
        ['GABA', 'gamma–aminobutyric acid'],
        ['HR', 'heart rate'],
        ['IC<sub>50</sub>', 'half maximal inhibitory concentration'],
        ['ITC', 'indirect treatment comparison'],
        ['Ki', 'inhibitory constant'],
        ['LA', 'last assessment'],
        ['LOCF', 'last observation carried forward'],
        ['LS', 'least squares'],
        ['MCID', 'minimal clinically important difference'],
      ],
      [
        ['mITT', 'modified intent-to-treat'],
        ['MOA', 'mechanism of action'],
        ['MWT', 'Maintenance of Wakefulness Test'],
        ['MWT20', 'Maintenance of Wakefulness Test performed over 20 minutes'],
        ['MWT30', 'Maintenance of Wakefulness Test performed over 30 minutes'],
        ['MWT40', 'Maintenance of Wakefulness Test performed over 40 minutes'],
        ['NET', 'norepinephrine transporter'],
        ['NR', 'not reported'],
        ['OSA', 'obstructive sleep apnea'],
        ['PAP', 'positive airway pressure'],
        ['PGI-C', 'Patient Global Impression of Change'],
        ['PI', 'prescribing information'],
        ['PS', 'parent study'],
        ['Q1', '25th percentile'],
        ['Q3', '75th percentile'],
        ['qd', 'daily'],
        ['RW', 'randomized withdrawal'],
        ['SBP', 'systolic blood pressure'],
        ['SD', 'standard deviation'],
        ['SDLP', 'standard deviation of lateral position'],
        ['SE', 'standard error'],
        ['SERT', 'serotonin transporter'],
        ['SF36v2', '36-Item Short Form Health Survey version 2'],
        ['TEAEs', 'treatment-emergent adverse events'],
        ['THAT', 'Toronto Hospital Alertness Test'],
        ['USA', 'United States of America'],
        ['V', 'visit'],
        ['WPA', 'wake-promoting agent'],
        ['WPAI', 'Work Productivity and Activity Impairment Questionnaire'],
      ],
    ],
    references: [
      'Adderall. Prescribing information. Teva Pharmaceuticals USA, Inc; 2017.',
      'Baladi MG, Forster MJ, Gatch MB, et al. Characterization of the neurochemical and behavioral effects of solriamfetol (JZP-110), a selective dopamine and norepinephrine reuptake inhibitor. <em>J Pharmacol Exp Ther.</em> 2018;366(2):367-376. doi:10.1124/jpet.118.248120',
      'Black JE, Hirshkowitax M. Modafinil for treatment of residual excessive sleepiness in nasal continuous positive airway pressure-treated obstructive sleep apnea/hypopnea syndrome. <em>Sleep.</em> 2005;28(4):464-471. doi:10.1093/sleep/28.4.464',
      'Bogan R, Stern T, Villa KF, et al. Function and work productivity measures in a phase 3, randomized, placebo-controlled, double-blind, multicenter, 12-week study of the safety and efficacy of JZP-110 for the treatment of excessive sleepiness in patients with obstructive sleep apnea. Poster presented at: SLEEP 2017, the 31st Annual Meeting of the Associated Professional Sleep Societies; June 3-7, 2017; Boston, MA.',
      'Bogan RK, Feldman N, Emsellem HA, et al. Effect of oral JZP-110 (ADX-N05) treatment on wakefulness and sleepiness in adults with narcolepsy. <em>Sleep Med.</em> 2015;16(9):1102-1108. doi:10.1016/j.sleep.2015.05.013',
      'Bron M, Ronnebaum S, Kratochvil D, et al. Indirect treatment comparison of the efficacy of solriamfetol, modafinil, and armodafinil for the treatment of excessive daytime sleepiness in obstructive sleep apnea. Poster presented at: World Sleep; September 20-25, 2019; Vancouver, BC.',
      'Data on file, Jazz Pharmaceuticals.',
      'Dinges DF, Weaver TE. Effects of modafinil on sustained attention performance and quality of life in OSA patients with residual sleepiness while being treated with nCPAP. <em>Sleep Med.</em> 2003;4(5):393-402. doi:10.1016/s1389-9457(03)00108-4',
      'German CL, Baladi MG, McFadden LM, Hanson GR, Fleckenstein AE. Regulation of the dopamine and vesicular monoamine transporters: Pharmacological targets and implications for disease. <em>Pharmacol Rev.</em> 2015;67(4):1005-1024. doi:10.1124/pr.114.010397',
      'Heal DJ, Smith SL, Gosden J, Nutt DJ. Amphetamine, past and present — a pharmacological and clinical perspective. <em>J Psychopharmacol</em>. 2013;27(6):479-496. doi:10.1177/0269881113482532',
      'Hirshkowitz M, Black JE, Wesnes K, Niebler G, Arora S, and Roth T. Adjunct armodafinil improves wakefulness and memory in obstructive sleep apnea/hypopnea syndrome. <em>Respir Med.</em> 2007;101(3):616-627. doi:10.1016/j.rmed.2006.06.007',
      'Inoue Y, Takasaki Y, Yamashiro Y. Efficacy and safety of adjunctive modafinil treatment on residual excessive daytime sleepiness among nasal continuous positive airway pressure-treated Japanese patients with obstructive sleep apnea syndrome: a double-blind placebo-controlled study. <em>J Clin Sleep Med.</em> 2013;9(8):751-757. doi:10.5664/jcsm.2912',
      'Jongen S, Vermeeren A, van der Sluiszen NNJJM, et al. A pooled analysis of on-the-road highway driving studies in actual traffic measuring standard deviation of lateral position (i.e., "weaving") while driving at a blood alcohol concentration of 0.5 g/L. <em>Psychopharmacology (Berl).</em> 2017;234(5):837-844. doi:10.1007/s00213-016-4519-z',
      'Malhotra A, Shapiro C, Pepin JL, et al. Long-term study of the safety and maintenance of efficacy of solriamfetol (JZP-110) in the treatment of excessive sleepiness in participants with narcolepsy or obstructive sleep apnea. <em>Sleep.</em> 2020;43(2):zsz220. doi:10.1093/sleep/zsz220',
      'Nuvigil. Prescribing information. Teva Pharmaceuticals USA, Inc; 2018.',
      'Pack AI, et al. Modafinil as adjunct therapy for daytime sleepiness in obstructive sleep apnea. <em>Am J Respir Crit Care Med.</em> 2001;164(9):1675-1681. doi:10.1164/arjccm.164.9.2103032',
      'Provigil. Prescribing information. Teva Pharmaceuticals USA, Inc; 2018.',
      'Ramaekers JG. Drugs and driving research in medicinal drug development. <em>Trends Pharmacol Sci.</em> 2017;38(4):319-321. doi:10.1016/j.tips.2017.01.006',
      'Rosenberg R, Schweitzer PK, Malhotra A, et al. Incidence and duration of common adverse events in a solriamfetol phase 3 study for the treatment of excessive daytime sleepiness in obstructive sleep apnea. Poster presented at: SLEEP 2019, the 33rd Annual Meeting of the Associated Sleep Societies; June 8-12, 2019; San Antonio, TX.',
      'Roth T, White D, Schimidt-Nowara W, et al. Effects of armodafinil in the treatment of residual excessive sleepiness associated with obstructive sleep apnea/hypopnea syndrome: a 12-week multicenter, double-blind, randomized, placebo-controlled study in nCPAP-adherent adults. <em>Clin Ther.</em> 2006;28(5):689-706. doi:10.1016/j.clinthera.2006.05.013',
      'Ruoff C, Swick TJ, Doekel R, et al. Effect of oral JZP-110 (ADX-N05) on wakefulness and sleepiness in adults with narcolepsy: a phase 2b study. <em>Sleep.</em> 2016;39(7):1379-1387. doi:10.5665/sleep.5968',
      'Schweitzer PK, Mayer G, Rosenberg R, et al. Randomized controlled trial of solriamfetol for excessive daytime sleepiness in OSA: an analysis of subgroups adherent or nonadherent to OSA treatment. <em>Chest.</em> 2021;S0012-3692(21)00341-X. doi:10.1016/j.chest.2021.02.033',
      'Schweitzer PK, Rosenberg R, Zammit GK, et al. Solriamfetol for excessive sleepiness in obstructive sleep apnea (TONES 3). <em>Am J Respir Crit Care Med.</em> 2019;199(11):1421-1431. doi:10.1164/rccm.201806-1100OC',
      'Schweitzer PK, Strohl KP, Mayer G, et al. Effects of solriamfetol in a long-term trial of participants with obstructive sleep apnea who are adherent or nonadherent to airway therapy. <em>J Clin Sleep Med.</em> <span style="white-space: nowrap">2021;17(4):659-668.</span> doi:10.5664/jcsm.8992',
      'Strollo Jr PJ, Hedner J, Collop N, et al. Solriamfetol for the treatment of excessive sleepiness in OSA: a placebo-controlled randomized withdrawal study. <em>Chest.</em> 2019;155(2):364-374. doi:10.1016/j.chest.2018.11.005',
      'Strollo PJ, Malhotra A, Strohl K, et al. Effects of soliramfetol on 24-hour blood pressure patterns in participants with excessive daytime sleepiness associated with obstructive sleep apnea. Poster presented at: SLEEP 2020, Associated Professional Sleep Societies Annual Meeting; August 27-30, 2020.',
      'Sunosi. United States prescribing information. Jazz Pharmaceuticals; 2019.',
      'Thorpy MJ, Shapiro C, Mayer G, et al. A randomized study of solriamfetol for excessive sleepiness in narcolepsy. <em>Ann Neurol.</em> 2019;85(3):359-370. doi:10.1002/ana.25423',
      'Vinckenbosch F, Asin J, de Vries N, et al. Effects of solriamfetol on driving performance in participants with excessive daytime sleepiness associated with obstructive sleep apnea. Poster presented at: SLEEP 2020 Associated Professional Sleep Societies Annual Meeting; August 2-30, 2020.',
      'Weaver TE, Drake CL, Benes H, et al. Effects of solriamfetol on quality-of-life measures from a 12-week phase 3 randomized controlled trial. <em>Ann Am Thorac Soc.</em> 2020;17(8):998-1007. doi:10.1513/annalsats.202002-136OC',
      'Wisor J. Modafinil as a catecholaminergic agent: empirical evidence and unanswered questions. <em>Front Neurol.</em> 2013;4:139. doi:10.3389/fneur.2013.00139',
    ],
  },

  // Tooltip Navigation
  tooltipList: [
    {
      label: 'TONES 3',
      value: 'tones-3',
    },
    {
      label: 'TONES 5',
      value: 'tones-5',
    },
    {
      label: 'Indirect Treatment Comparison (ITC)',
      value: 'itc',
    },
    {
      label: 'Driving Study',
      value: 'driving',
    },
  ],

  checkList: [
    {
      id: 0,
      label: 'Solriamfetol',
      element: 'dark',
      disabled: false,
      active: false,
      metadata: {
        stitchVideo: stitchVidOne,
        stitchVideoThumb: stitchPic,
      },
      cards: [
        {
          video: solVidOne,
          thumbnail: dopeThumbnail,
          body: 'Solriamfetol binds to the dopamine transporter with low affinity (Ki = 14.2 μM) and inhibits the reuptake of dopamine with low potency (IC<sub>50</sub> = 2.9 μM).<sup>27</sup>',
          popup:
            'Solriamfetol has no appreciable binding affinity to dopamine, serotonin, norepinephrine, GABA, adenosine, histamine, orexin, benzodiazepine, muscarinic acetylcholine, or nicotinic acetylcholine receptors.<sup>27</sup>',
        },
        {
          video: solVidTwo,
          thumbnail: noreThumbnail,
          body: 'Solriamfetol binds to the norepinephrine transporter with low affinity (3.7 μM) and inhibits the reuptake of norepinephrine with low potency (4.4 μM).<sup>27</sup>',
          popup:
            'Solriamfetol has no appreciable binding affinity to dopamine, serotonin, norepinephrine, GABA, adenosine, histamine, orexin, benzodiazepine, muscarinic acetylcholine, or nicotinic acetylcholine receptors.<sup>27</sup>',
        },
        {
          video: solVidThree,
          thumbnail: seroThumbnail,
          body: 'Solriamfetol has no appreciable binding affinity for the serotonin transporter (Ki = 81.5 μM) and does not inhibit serotonin reuptake (IC<sub>50</sub> > 100 μM).<sup>27</sup>',
          popup:
            'Solriamfetol has no appreciable binding affinity to dopamine, serotonin, norepinephrine, GABA, adenosine, histamine, orexin, benzodiazepine, muscarinic acetylcholine, or nicotinic acetylcholine receptors.<sup>27</sup>',
        },
      ],
    },
    {
      id: 1,
      label: 'WPA',
      element: 'light',
      disabled: false,
      active: false,
      metadata: {
        stitchVideo: stitchVidTwo,
        stitchVideoThumb: stitchPic,
      },
      cards: [
        {
          video: wpaVidOne,
          thumbnail: dopeThumbnail,
          body: 'Other WPAs (such as modafinil and armodafinil) bind the DAT and inhibit dopamine reuptake in vitro.<sup>15,17</sup>',
          popup: '',
        },
        {
          video: wpaVidTwo,
          thumbnail: noreThumbnail,
          body: 'Based on the current available data, there is limited evidence that other WPAs (modafinil, armodafinil) interact with NET.<sup>15,31</sup>',
          popup: '',
        },
        {
          video: wpaVidThree,
          thumbnail: seroThumbnail,
          body: 'Based on current available data, other WPAs (such as modafinil and armodafinil) have no affinity for SERT.<sup>15,31</sup>',
          popup: '',
        },
      ],
    },
    {
      id: 2,
      label: 'Traditional Stimulants',
      element: 'medium',
      disabled: false,
      active: false,
      metadata: {
        stitchVideo: stitchVidThree,
        stitchVideoThumb: stitchPic,
      },
      cards: [
        {
          video: amphVidOne,
          thumbnail: dopeThumbnail,
          body: 'Traditional stimulants (such as amphetamines) are thought to both block the reuptake of dopamine into the presynaptic neuron and increase the release of monoamines into the extraneuronal space.<sup>1</sup>',
          popup: '',
        },
        {
          video: amphVidTwo,
          thumbnail: noreThumbnail,
          body: 'Traditional stimulants (such as amphetamines) are thought to both block the reuptake of norepinephrine into the presynaptic neuron and increase the release of  monoamines into the extraneuronal space.<sup>1</sup>',
          popup: '',
        },
        {
          video: amphVidThree,
          thumbnail: seroThumbnail,
          body: 'Traditional stimulants (such as amphetamines) are thought to both block the reuptake of serotonin into the presynaptic neuron and increase the release of monoamines into the extraneuronal space.<sup>2,10</sup>',
          popup: '',
        },
      ],
    },
  ],
};
